import { Pipe, PipeTransform } from "@angular/core";
import { FullClient, FullClientType } from "@models/full-client.model";
import { ClientDroits, ClientDroitsLibelle } from "@jack-sparrow-libraries/emotion-models";

@Pipe({
	name: "fullClientRole",
	standalone: true,
})
export class FullClientRolePipe implements PipeTransform {
	transform(client: FullClient): string | null {
		if (!client) {
			return null;
		}
		return this.getClientRoleLabel(client);
	}

	private getClientRoleLabel(client: FullClient) {
		if (
			client.droits === ClientDroits.Remplacant ||
			client.droits === ClientDroits.Remplacant_Sans_Acces_Donnees ||
			client.droits === ClientDroits.Remplacant_Acces_Personnalise
		) {
			const psName = this.getRemplacantPsName(client);
			return `${ClientDroitsLibelle.Remplacant} ${psName ? "de " + psName : ""}`.trim() || null;
		} else if (
			client.droits === ClientDroits.Marketing ||
			client.droits === ClientDroits.Hotliner ||
			client.droits === ClientDroits.SuperAdmin
		) {
			return ClientDroitsLibelle[ClientDroits[client.droits]];
		} else {
			return "Titulaire";
		}
	}

	private getRemplacantPsName(fullClient: FullClient) {
		// On affiche le titulaire REMPLACÉ (choisi à la connexion), porté par psRemplace pour un
		// remplaçant. Le `ps` hérité de Client est le titulaire CRÉATEUR et ne doit pas être affiché
		// ici (AY-10741). Fallback sur `ps` pour les cas hors type REMPLACANT.
		const ps = fullClient.type === FullClientType.REMPLACANT ? fullClient.psRemplace : fullClient.ps;
		return `${ps?.nom ?? ""} ${ps?.prenom ?? ""}`.trim() || null;
	}
}
